import React, { SyntheticEvent, useContext } from "react";
import { Dropdown } from "@cmsgov/ds-medicare-gov";
import { useTranslate, sendTealiumEvent } from "../../helpers";
import { AppStore } from "../../app/store";
import { ActionType, DrugCoverageFilterOption } from "../../@types";
import { defaultState } from "../../app/store/AppStore";

const DrugCoverageFilter: React.FunctionComponent<{
  onDrugCoverageUpdate: (carrier: string) => void;
}> = ({ onDrugCoverageUpdate }) => {
  const {
    state: { searchResultsFilters = defaultState.searchResultsFilters },
    dispatch,
  } = useContext(AppStore.AppContext);
  const { drugCoverageFilter } = searchResultsFilters;
  const t = useTranslate();

  return (
    <Dropdown
      onChange={(ev: SyntheticEvent<HTMLSelectElement>): void => {
        // istanbul ignore next: tested elsewhere
        sendTealiumEvent(
          "Find Plans - Available Plans",
          "Drug Coverage Options Pull down"
        );
        dispatch({
          type: ActionType.UPDATE_SEARCH_RESULTS_FILTERS,
          payload: {
            ...searchResultsFilters,
            drugCoverageFilter: ev.currentTarget
              .value as DrugCoverageFilterOption,
          },
        });
        onDrugCoverageUpdate(ev.currentTarget.value);
      }}
      name="drug-coverage-filter"
      value={drugCoverageFilter}
      label={t("search_results_page.drug_coverage_options")}
      id="drug-coverage-filter"
      options={[]}
    >
      <option value="" aria-selected={!drugCoverageFilter}>
        {t("search_results_page.select_drug_coverage")}
      </option>
      <option
        value={DrugCoverageFilterOption.INCLUDES}
        selected={drugCoverageFilter === DrugCoverageFilterOption.INCLUDES}
      >
        {t("search_results_page.includes_drug_coverage")}
      </option>
      <option
        value={DrugCoverageFilterOption.EXCLUDES}
        selected={drugCoverageFilter === DrugCoverageFilterOption.EXCLUDES}
      >
        {t("search_results_page.excludes_drug_coverage")}
      </option>
    </Dropdown>
  );
};

export default DrugCoverageFilter;
